import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';

/**
 * Renders site logo with image and site name as screen-reader only h1 content.
 * @param String siteName Site name text string, read by screen readers
 * @param String homeHref Site root href, defaults to '/'
 * @param String logoSrc  SVG string for logo
 */
var Logo = function Logo(_ref) {
  var props = _extends({}, _ref); // console.log('Logo')


  return /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement("a", {
    href: props.siteHref
  }, !!props.logoSrc ? /*#__PURE__*/React.createElement("div", {
    className: "logo",
    dangerouslySetInnerHTML: {
      __html: props.logoSrc
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }), /*#__PURE__*/React.createElement("span", {
    className: "logo-sitename"
  }, props.siteName)));
};

Logo.defaultProps = {
  siteName: "Site Name",
  homeHref: "/",
  logoSrc: "<svg width=\"150\" height=\"50\">\n            <rect width=\"150\" height=\"50\" style=\"fill:#545b62;stroke-width:3;stroke:#545b62\" />\n          </svg>"
};
export default Logo;